import React from 'react';
import Content from './content/Content';
import Navigation from './navigation/Navigation';

const App = () => {
  return (
    <>
      <Navigation />
      <Content />
    </>
  );
};

export default App;
